let prepareClose = null;
const closing = new WeakSet();
const preparing = new WeakSet();

/** Register the reader only after its lazy runtime has loaded. */
export function setTicketEmailCloseHandler(handler) { prepareClose = handler; }

/** Fancybox shouldClose is synchronous; resume its ordinary close once drafts are safe. */
export function guardTicketEmailClose(fancybox) {
    if (closing.delete(fancybox)) return true;
    const scope = fancybox.$container;
    if (!prepareClose || !scope?.querySelector('[data-ticket-emails], [data-ticket-timeline][data-ticket-id]')) return true;
    if (!preparing.has(fancybox)) {
        preparing.add(fancybox);
        prepareClose(scope).then((ready) => {
            if (!ready) return;
            closing.add(fancybox);
            fancybox.close();
        }).catch(() => {
            // The active reader retains its draft and presents its own save error.
        }).finally(() => preparing.delete(fancybox));
    }
    return false;
}
